import { Grid, SvgIcon } from "@mui/material";
import React from "react";
import Step2 from "../../images/step2";
import Step3 from "../../images/step3";
import Step4 from "../../images/step4";
import { StyledGrid } from "../style/StyledComponents";
import PodcastIntroStep1 from "../../images/Podcast_Intro_Step1";

const PodcastIntroImages = () => {

    const Iconstyle={ width: '100%', maxWidth:'300px', height:"auto"}
    const IconGridSx={ display: 'flex', justifyContent: 'center', alignItems: 'center', maxHeight: "250px"}
    return (
        <>
          <StyledGrid container>
            <Grid item xs={12} sm={6} md={3} xl={3} padding={{xs:2, sm:2}}>
              <SvgIcon style={Iconstyle}> 
                <PodcastIntroStep1 />
              </SvgIcon>
            </Grid>
            <Grid item xs={12} sm={6} md={3} xl={3} padding={2} sx={IconGridSx}>
              <SvgIcon style={Iconstyle}> 
                <Step2 />
              </SvgIcon>
            </Grid>
            <Grid item xs={12} sm={6} md={3} xl={3} padding={2} sx={IconGridSx}>
              <SvgIcon style={Iconstyle}> 
                <Step3 />
              </SvgIcon>
            </Grid>
            <Grid item xs={12} sm={6} md={3} xl={3} padding={{xs:0, sm:2}} sx={IconGridSx}>
              <SvgIcon style={Iconstyle}> 
                <Step4 />
              </SvgIcon>
            </Grid>
          </StyledGrid>
        </>
    );
}

export default PodcastIntroImages;